import { useEffect, useState } from 'react';
function formatearFechaEvento(fecha) {
  if (!fecha) {
    return {
      fecha: 'Sin fecha',
      hora: 'Sin hora'
    };
  }

  const date = new Date(fecha);

  if (Number.isNaN(date.getTime())) {
    return {
      fecha: 'Sin fecha',
      hora: 'Sin hora'
    };
  }

  return {
    fecha: date.toLocaleDateString('es-CO', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    }),
    hora: date.toLocaleTimeString('es-CO', {
      hour: 'numeric',
      minute: '2-digit'
    })
  };
}
const obtenerDireccionGoogle = (lat, lng) => {
  return new Promise((resolve) => {
    if (!lat || !lng || !window.google?.maps) {
      resolve('Dirección no disponible');
      return;
    }

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode(
      {
        location: {
          lat: Number(lat),
          lng: Number(lng)
        }
      },
      (results, status) => {
        if (status === 'OK' && results?.[0]) {
          resolve(results[0].formatted_address);
        } else {
          resolve('Dirección no disponible');
        }
      }
    );
  });
};
function EventsPanel({
  vehiculoSeleccionado,
  monitorUserId,
  isMobile = false
}) {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorCarga, setErrorCarga] = useState('');
  const [eventoDetalle, setEventoDetalle] = useState(null);
const [direccionDetalle, setDireccionDetalle] = useState('');
const [cargandoDireccion, setCargandoDireccion] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const vehicleId = vehiculoSeleccionado?.maccezVehicleId ?? vehiculoSeleccionado?.id;
    let pending = false;
    setEventos([]);
    setEventoDetalle(null);
    setErrorCarga('');
    setLoading(Boolean(vehicleId));
    if (!vehicleId || !monitorUserId) {
      setLoading(false);
      return () => controller.abort();
    }

    async function cargarEventos() {
      if (pending || controller.signal.aborted) return;
      pending = true;
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(
          `/api/events?vehicleId=${encodeURIComponent(vehicleId)}&monitorUserId=${encodeURIComponent(monitorUserId)}&limit=100`,
          {
            headers: { Authorization: `Bearer ${token}` },
            signal: controller.signal
          }
        );
        if (!response.ok) throw new Error('No se pudieron cargar los eventos.');
        const data = await response.json();
        if (!controller.signal.aborted) {
          setEventos(Array.isArray(data.events) ? data.events : []);
          setErrorCarga('');
        }
      } catch (error) {
        if (controller.signal.aborted) return;
        console.error('ERROR CARGANDO EVENTOS:', error);
        setErrorCarga('No se pudieron actualizar los eventos.');
      } finally {
        pending = false;
        if (!controller.signal.aborted) setLoading(false);
      }
    }

    cargarEventos();
    const intervaloEventos = setInterval(cargarEventos, 15000);
    return () => {
      controller.abort();
      clearInterval(intervaloEventos);
    };
  }, [vehiculoSeleccionado?.maccezVehicleId, vehiculoSeleccionado?.id, monitorUserId]);
const verDetalleEvento = async (evento) => {
  setEventoDetalle(evento);
  setDireccionDetalle('');

  if (!evento.latitude || !evento.longitude) {
    setDireccionDetalle(
      'Este evento no tiene ubicación registrada.'
    );
    return;
  }

  try {
    setCargandoDireccion(true);

    const direccion = await obtenerDireccionGoogle(
      evento.latitude,
      evento.longitude
    );

    setDireccionDetalle(direccion);
  } finally {
    setCargandoDireccion(false);
  }
};


  return (
    <div style={{ ...styles.wrapper, ...(isMobile ? styles.wrapperMobile : {}) }}>
      {errorCarga && <p role="alert" style={{ ...styles.error, ...(isMobile ? styles.errorMobile : {}) }}>{errorCarga}</p>}

      {loading && eventos.length === 0 ? (
        <p style={{ ...styles.empty, ...(isMobile ? styles.emptyMobile : {}) }}>Cargando eventos...</p>
      ) : eventos.length === 0 ? (
        <p style={{ ...styles.empty, ...(isMobile ? styles.emptyMobile : {}) }}>
          {vehiculoSeleccionado
            ? 'No hay eventos recientes para este activo.'
            : 'Selecciona un activo para ver sus eventos.'}
        </p>
      ) : (
        <div style={{ ...styles.list, ...(isMobile ? styles.listMobile : {}) }}>
         {eventos.map((evento) => {
  const fechaEvento = formatearFechaEvento(evento.created_at);

  return (
    <div key={evento.id} style={{ ...styles.item, ...(isMobile ? styles.itemMobile : {}) }}>
      <div style={{ ...styles.dot, ...(isMobile ? styles.dotMobile : {}) }} />

   <div style={styles.eventContent}>
  <div style={styles.eventInfo}>
    <div style={{ ...styles.title, ...(isMobile ? styles.titleMobile : {}) }}>
      {evento.title || 'Evento registrado'}
    </div>

  <div style={{ ...styles.eventBottomRow, ...(isMobile ? styles.eventBottomRowMobile : {}) }}>
      <div style={{ ...styles.time, ...(isMobile ? styles.timeMobile : {}) }}>
        {fechaEvento.fecha} · {fechaEvento.hora}
      </div>

      <button
        type="button"
        onClick={() => verDetalleEvento(evento)}
        style={{ ...styles.detailButton, ...(isMobile ? styles.detailButtonMobile : {}) }}
      >
        Ver detalle
      </button>
    </div>
  </div>

  {eventoDetalle?.id === evento.id && (
    <div style={{ ...styles.detailBox, ...(isMobile ? styles.detailBoxMobile : {}) }}>
     <div style={styles.detailContent}>
  <span style={{ ...styles.detailAddressText, ...(isMobile ? styles.detailAddressTextMobile : {}) }}>
    {cargandoDireccion
      ? 'Consultando dirección...'
      : direccionDetalle || 'Dirección no disponible'}
  </span>
</div>

      <button
        type="button"
        onClick={() => {
          setEventoDetalle(null);
          setDireccionDetalle('');
        }}
        style={{ ...styles.closeDetail, ...(isMobile ? styles.closeDetailMobile : {}) }}
      >
        ×
      </button>
    </div>
  )}
</div>
    </div>
  );
})}
        </div>
      )}

     
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  wrapperMobile: { gap: '12px' },
  listMobile: { gap: '10px' },
  error: { margin: 0, color: '#fecaca', fontSize: '12px' },
  errorMobile: { color: '#b91c1c' },
  emptyMobile: {
    color: '#475569', background: '#fff', borderRadius: '18px', padding: '18px',
    boxShadow: '0 6px 18px rgba(15,23,42,0.05)'
  },
  itemMobile: {
    padding: '16px', gap: '12px', gridTemplateColumns: '10px minmax(0, 1fr)',
    borderRadius: '19px', background: '#fff',
    border: '1px solid rgba(226,232,240,0.94)',
    boxShadow: '0 8px 22px rgba(15,23,42,0.07)'
  },
  dotMobile: { background: '#38bdf8', width: '9px', height: '9px' },
  titleMobile: { color: '#0f172a', fontSize: '15px', lineHeight: '1.35' },
  eventBottomRowMobile: { flexWrap: 'wrap' },
  timeMobile: { color: '#64748b', whiteSpace: 'normal', fontSize: '12px' },
  detailButtonMobile: {
    minHeight: '36px', fontSize: '12px', color: '#0755a0',
    background: '#eef6ff', border: '1px solid #c7ddfa'
  },
  detailBoxMobile: {
    color: '#17345c', background: '#f1f7ff', border: '1px solid #d8e8fa'
  },
  detailAddressTextMobile: { color: '#334155', fontSize: '13px', lineHeight: '1.45' },
  closeDetailMobile: { background: '#fff', color: '#0f172a', border: '1px solid #d8e8fa' },

  summaryCard: {
    padding: '14px',
    borderRadius: '16px',
    background: 'rgba(3,18,40,0.62)',
    border: '1px solid rgba(56,189,248,0.20)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#dbeafe',
    fontSize: '13px',
    fontWeight: '800'
  },

  contextBox: {
    padding: '9px 11px',
    borderRadius: '12px',
    background: 'rgba(14,165,233,0.12)',
    border: '1px solid rgba(125,211,252,0.18)',
    color: '#bfdbfe',
    fontSize: '11px',
    fontWeight: '700'
  },

  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '7px'
  },

  item: {
    display: 'grid',
    gridTemplateColumns: '8px 1fr',
    gap: '8px',
    padding: '8px 10px',
    borderRadius: '13px',
    background: 'rgba(15,23,42,0.66)',
    border: '1px solid rgba(96,165,250,0.14)'
  },

  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: '#38bdf8',
    marginTop: '4px'
  },

  eventContent: {
    display: 'grid',
    gap: '7px',
    minWidth: 0
  },

  eventInfo: {
    display: 'grid',
    gap: '5px',
    minWidth: 0
  },

  eventBottomRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px'
  },

  title: {
    color: '#ffffff',
    fontSize: '12px',
    fontWeight: '800',
    lineHeight: '1.2'
  },

  message: {
    marginTop: '3px',
    color: '#cbd5e1',
    fontSize: '10px',
    fontWeight: '600',
    lineHeight: '1.3'
  },

  time: {
    color: '#93c5fd',
    fontSize: '10px',
    fontWeight: '700',
    whiteSpace: 'nowrap'
  },

  empty: {
    margin: 0,
    color: '#cbd5e1',
    fontSize: '13px',
    lineHeight: '1.5'
  },

  detailButton: {
    padding: '5px 9px',
    borderRadius: '9px',
    border: '1px solid rgba(56,189,248,0.28)',
    background: 'rgba(14,165,233,0.14)',
    color: '#bae6fd',
    fontSize: '10px',
    fontWeight: '800',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  },

  detailBox: {
    display: 'grid',
    gridTemplateColumns: '1fr 26px',
    gap: '10px',
    alignItems: 'center',
    padding: '9px 10px',
    borderRadius: '12px',
    background: 'rgba(2,6,23,0.88)',
    border: '1px solid rgba(56,189,248,0.24)',
    color: '#e0f2fe'
  },

detailContent: {
  display: 'block',
  minWidth: 0
},
  detailTitle: {
    color: '#ffffff',
    fontSize: '11px',
    fontWeight: '800',
    lineHeight: '1.25'
  },

  detailAddressText: {
    color: '#bfdbfe',
    fontSize: '10px',
    fontWeight: '600',
    lineHeight: '1.35',
    minWidth: 0,
    overflowWrap: 'anywhere'
  },

  closeDetail: {
    width: '26px',
    height: '26px',
    padding: 0,
    borderRadius: '8px',
    border: '1px solid rgba(255,255,255,0.12)',
    background: 'rgba(15,23,42,0.95)',
    color: '#ffffff',
    cursor: 'pointer'
  }
};

export default EventsPanel;
